import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { RouteFormData } from '../../../../shared/models/route-form-data';

@Component({
  selector: 'app-route-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, MatButtonModule, MatIconModule, MatDialogTitle, MatDialogContent],
  templateUrl: './route-form.html',
  styleUrl: './route-form.css'
})
export class RouteForm {
    routeForm: FormGroup;
    isEditMode: boolean = false;
    private _routeIdToUpdate: string | null = null;

    constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<RouteForm, RouteFormData | undefined>, @Inject(MAT_DIALOG_DATA) public data: RouteFormData | null) {
        this.isEditMode = !!data;

        if(this.isEditMode) {
            this._routeIdToUpdate = data?.id || null;
        }

        console.log(this._routeIdToUpdate);

        this.routeForm = this.fb.group({
			name: [data?.name || '', [Validators.required]],
            status: [data?.status ?? true]
        });
    }

    get nameControl() {
        return this.routeForm.get('name');
    }

    onSubmit(): void {
        this.routeForm.markAllAsTouched();
            
		if(this.routeForm.valid) {
            const formData = this.routeForm.value;
            let   resultData: RouteFormData;
            
            if(this.isEditMode && this._routeIdToUpdate) {
                resultData = { ...formData, id: this._routeIdToUpdate } as RouteFormData;
            } else {
                resultData = formData as RouteFormData;
            }
            
            this.dialogRef.close(resultData);
        }
    }

    onCancel(): void {
        this.dialogRef.close(undefined);
    }
}
